import { SeverityLevel, withScope, captureException as capture } from '@sentry/capacitor'

export const captureException = (error: unknown, level: SeverityLevel, tag?: string) => {
  // PREGNANT-APP-EW: localforage/IndexedDB rejects with `null` when storage is
  // transiently unavailable. There is no message or stack to send, and the old
  // normalization turned it into `Error: null` spam. Drop it, not Sentry-worthy.
  if (error === null || error === undefined) {
    return
  }

  withScope(function (scope) {
    scope.setLevel(level)
    tag && scope.setTag('internal-capture', tag)

    const normalizedError =
      error instanceof Error
        ? error
        : new Error(
            typeof error === 'string'
              ? error
              : typeof error === 'object'
                ? ('message' in error && typeof error.message === 'string' && error.message) || JSON.stringify(error)
                : String(error),
            { cause: error },
          )

    scope.setExtra('name', normalizedError.name)
    scope.setExtra('message', normalizedError.message)
    scope.setExtra('stack', normalizedError.stack)
    capture(normalizedError, () => scope)
  })
}
